<template>
  <footer
    class="flex flex-wrap items-center justify-between gap-3 border-t border-[rgba(219,225,235,0.08)] bg-[#050816] px-4 py-5 text-sm sm:px-12"
  >
    <span class="text-[#3FD0EA]">
      © {{ new Date().getFullYear() }} Exfluential. All Rights Reserved.
    </span>
    <nav aria-label="Legal" class="flex gap-5">
      <a
        href="https://exfluential.com/privacy-policy"
        class="text-[#94A3B8] hover:text-white"
      >
        Privacy Policy
      </a>
      <a
        href="https://exfluential.com/exfluential-terms"
        class="text-[#94A3B8] hover:text-white"
      >
        Terms of Service
      </a>
    </nav>
  </footer>
</template>
